import { useState } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from 'libs/searchspring/hooks/useBeaconAnalytics'
import { ResultsCard } from 'libs/searchspring/components/ResultCard'
import { SkeletonCard } from 'libs/searchspring/components/SkeletonCard'
import clsx from 'clsx'

export function BaseResults({
  className,
  wrapperClassName = '',
  productCardOptions,
  renderWrapper
}) {
  const { results, isLoading } = useSearchspringContext()
  const [node, setNode] = useState()

  // Analytics related hooks
  useBeaconLogRender()
  useBeaconLogImpressions(node)

  if (results?.results?.length === 0 && !isLoading) return null

  // Create placeholder array based on either results length or default count
  const placeholderCount = results?.results?.length || 8
  const items = Array.from({ length: placeholderCount }, (_, index) => ({
    id: index,
    result: results?.results?.[index]
  }))

  const renderItems = () => items.map(({ id, result }) => (
    <div className={clsx(className, 'shrink-0')} key={result?.handle || id}>
      {isLoading || !results?.results ? (
        <SkeletonCard
          className="grow"
          {...(productCardOptions && { options: productCardOptions })}
        />
      ) : (
        <ResultsCard
          result={result}
          className="max-h-full wk-wishlist-button-target grow"
          {...(productCardOptions && { options: productCardOptions })}
        />
      )}
    </div>
  ))

  return (
    <div ref={setNode} className={clsx('relative flex w-full', wrapperClassName)}>
      {renderWrapper ? renderWrapper(renderItems()) : renderItems()}
    </div>
  )
}
